export default __webpack_public_path__ + "static/media/delwar.be4561ea.jpg";